import { Link } from 'react-router-dom'
import { UserCircleIcon } from '@heroicons/react/24/solid'
import { Card, CardContent } from '@mui/material'
import { UserStatus } from '../state/apiSlice'

interface UserListItemProps {
  userId: string
  status: UserStatus
}

export default function UserListItem(props: Readonly<UserListItemProps>) {
  const statusStyles = {
    [UserStatus.ACTIVE]: { color: "green", label: "Active" },
    [UserStatus.INVITED]: { color: "blue", label: "Invited" },
    [UserStatus.INACTIVE]: { color: "gray", label: "Inactive" },
  } as const

  const dot500 = {
    green: "bg-green-500",
    blue: "bg-blue-500",
    gray: "bg-gray-500",
  } as const

  const ping400 = {
    green: "bg-green-400",
    blue: "bg-blue-400",
    gray: "",
  } as const

  const { color, label } = statusStyles[props.status] || statusStyles[UserStatus.INACTIVE]

  return <Link to={`/stats/${props.userId}`}>
    <Card variant="outlined">
      <CardContent>
        <div className="flex items-center">
          <UserCircleIcon className="w-8 h-8 m-3" />
          <div className="ms-4 me-12">
            <h3 className="text-l font-bold">{props.userId}</h3>
            <div className="flex items-center">
              <span className="relative flex h-3 w-3 ms-0 m-2">
                {props.status !== UserStatus.INACTIVE && (
                  <span className={`animate-ping absolute inline-flex h-full w-full rounded-full ${ping400[color]} opacity-75`} />
                )}
                <span className={`relative inline-flex rounded-full h-3 w-3 ${dot500[color]}`} />
              </span>
              <p>{label}</p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  </Link>
}
